export default __webpack_public_path__ + "images/122851cdbbc66f8ad0a837a3a5c51191.svg";